// extracted by mini-css-extract-plugin
export default {"supportTabsDiv":"PreviewTabs_supportTabsDiv__btrTo","supportTab":"PreviewTabs_supportTab__Cup-w","yellowBackground":"PreviewTabs_yellowBackground__C-TkL"};